import * as actionTypes from "./LeadsType";

const INITIAL_STATE = {
  LeadsList: null,
  sourceList: [],
  LeadsCount: [],
  AssignList: [],
  LeadsFollowupHistory: [],
  LeadsListById: {},
  Leadssource: {},
  CustomerList: {},
  referenceList: [],
  attachmentData: [],
};

const LeadsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.SETLEADSLIST:
      return {
        ...state,
        LeadsList: action.payload,
      };
    case actionTypes.SETLEADSLISTBYID:
      return {
        ...state,
        LeadsListById: action.payload,
      };
    case actionTypes.SETLEADSCOUNT:
      return {
        ...state,
        LeadsCount: action.payload,
      };
    case actionTypes.SETLEADSFOLLWUPHISTORY:
      return {
        ...state,
        LeadsFollowupHistory: action.payload,
      };
    case actionTypes.SETASSIGNLIST:
      return {
        ...state,
        AssignList: action.payload,
      };
    case actionTypes.SETLEADSSOURCE:
      return {
        ...state,
        sourceList: action.payload.list.Data,
      };
    case actionTypes.SETLEADSCUSTOMERLIST:
      return {
        ...state,
        CustomerList: action.payload.list.Data,
      };
    case actionTypes.SETLEADSREFERENCE:
      return {
        ...state,
        referenceList: action.payload,
      };
    case actionTypes.SETATTACHMENTDATA:
      return {
        ...state,
        attachmentData: action.payload,
      };
    default:
      return state;
  }
};

export default LeadsReducer;
